<script>
    import ActionTop from "../widgets/ActionTop.svelte";
    import copy from 'copy-to-clipboard';
    import { slide } from 'svelte/transition';
    import { alertinfo } from '../store.js';
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    import { onMount } from "svelte";
    export let value;
    export let key;
    export let choose_panel;
    export let action_id;
    let types = ['one','two','three','four','five','six','seven'];
    let actions = {
        copiable: true, //是否可复制
        addable: true, //是否可增加
        reducable: true, //是否可减少
        disabled: false
    };
    onMount(() => {
        for(let type of types){
            value[type] = value[type] || [];
        }
    });
    $: {
        let c = 1;
        for(let type of types){
            c = c * value[type].length;
        }
        if(c > 0){
            actions.copiable = true;
            if(value.nums <= 1){
                actions.addable = true;
                actions.reducable = false;
            }else if(value.nums >= 99){
                actions.addable = false;
                actions.reducable = true;
            }else{
                actions.addable = true;
                actions.reducable = true;
            }
            value.price = c * value.nums * 2;
        }else{
            actions.disabled = true;
            actions.copiable = false;
            actions.addable = false;
            actions.reducable = false;
        }
    }
    const switchActionId = () => {
        action_id = action_id == key ? 0 : key;
    }
    const handleAdd = () => {
        value.nums += 1;
    }
    const handleReduce = () => {
        value.nums -= 1;
    }
    const handleCopy = () => {
        let text = 'https://xh.wangzhanb.com/ \r\n';
        text = text.concat('-----------------\r\n');
        text = text.concat('七星彩选号：\r\n');
        text = text.concat('复式 - ');
        text = text.concat(value.nums + '倍' + '\r\n');
        types.forEach((item,index) => {
            text = text.concat('第'+(index+1)+'位：'+value[item].sort((a, b) => {return a - b}).join('  ')) + '\r\n';
        });
        copy(text,{
            onCopy: alertinfo.set('内容已复制')
        });
    }
    const handleDel = () => {
        dispatch('del', {
			key: key
		});
    }
    const handleEdit = () => {
        choose_panel = key;
        action_id = 0;
    }
</script>
<div class="showball" transition:slide="{{ duration: 200 }}">
    {#if action_id == key}
    <ActionTop price={value.price} bind:nums={value.nums} bind:actions on:copy={handleCopy} on:edit={handleEdit} on:del={handleDel} on:add={handleAdd} on:reduce={handleReduce}/>
    {/if}
    {#each types as type,i}
    <div class="weilist">
        <span class="wei">第<i>{i + 1}</i>位：</span>
        <div class="ball-list {actions.disabled ? 'disabled' : ''}" on:click="{switchActionId}">
            {#each value[type] as val}
                <span class="{i < 6 ? 'ball-red': 'ball-blue'}"><i>{val}</i></span>
            {/each}
        </div>
    </div>
    {/each}
</div>
<style>
    .showball{
        background-color: #fff;
        box-sizing: border-box;
        padding: 0.3rem 0.1rem;
        border-radius: 0.9rem;
        width: calc(100% - 1rem);
        margin: 0.2rem auto 0.56rem;
        position: relative;
    }
    .showball .disabled::after{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, .5);
    }
    .weilist {
        width: 100%;
        display: flex;
        align-items: center;
    }
    .weilist .wei {
        width: 20%;
        display: inline-flex;
        justify-content: flex-end;
        font-size: .82rem;
        color: #383838;
        font-weight: bold;
    }
    .weilist .wei i{
        display: inline-block;
        padding: 0 .1rem;
        font-size: .9rem;
        font-family: "Baloo Chettan 2";
        font-style: normal;
    }
    .ball-list {
        position: relative;
        width: 80%;
        margin: .1rem 0;
    }

    .ball-list span {
        display: inline-block;
        width: 12.5%;
        position: relative;
        vertical-align: middle;
        text-align: center;
    }

    .ball-list span:before {
        content: "";
        display: inline-block;
        padding-bottom: 100%;
        width: 0.1rem;
        vertical-align: middle;
    }

    .ball-list i {
        font-style: normal;
        display: inline-flex;
        position: absolute;
        top: 0.1rem;
        left: 0.1rem;
        height: calc(100% - 0.2rem);
        width: calc(100% - 0.2rem);
        box-sizing: border-box;
        border-radius: 50%;
        font-size: 1rem;
        color: #383838;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
        font-family: "Baloo Chettan 2";
    }

    .ball-red i {
        background-color: #ff8080;
    }

    .ball-blue i {
        background-color: #7fb2e7;
    }
</style>